/**
 * @generated SignedSource<<b75b92ce536fd9e7fcd698c92577a59d>>
 * @relayHash f3e4eb6cbc15671c025448a6b8f3386a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 097d25120462db2fc5b530f09b21ab8a20b6e4505b7830695f84979384461086

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type useOnAttemptToUpgradeQuery$variables = {
  entitlementId: string;
};
export type useOnAttemptToUpgradeQuery$data = {
  readonly confluence_tenantContext: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null | undefined;
  readonly growthUnifiedProfile_getEntitlementProfile: {
    readonly lastKnownTrial: {
      readonly createdAt: number | null | undefined;
      readonly offeringId: string | null | undefined;
      readonly trialEndTimeStamp: number | null | undefined;
      readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useOnAttemptToUpgradeQuery = {
  response: useOnAttemptToUpgradeQuery$data;
  variables: useOnAttemptToUpgradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitlementId"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entitlementId",
        "variableName": "entitlementId"
      }
    ],
    "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
    "kind": "LinkedField",
    "name": "growthUnifiedProfile_getEntitlementProfile",
    "plural": false,
    "selections": [
      {
        "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
        "kind": "LinkedField",
        "name": "lastKnownTrial",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "trialEndTimeStamp"
          },
          {
            "kind": "ScalarField",
            "name": "trialType"
          },
          {
            "kind": "ScalarField",
            "name": "offeringId"
          },
          {
            "kind": "ScalarField",
            "name": "createdAt"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "097d25120462db2fc5b530f09b21ab8a20b6e4505b7830695f84979384461086",
    "metadata": {},
    "name": "useOnAttemptToUpgradeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "534e6ffeac5ad7e96470d5b9f9681151";

export default node;
